import { API } from './operations';

export const streamAiText = async ({ prompt, mode = 'generate', targetLang = '', onDelta }) => {
  const token = localStorage.getItem('eco-auth-token');
  const res = await fetch(`${API}/ai/generate`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'text/event-stream',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({ prompt, mode, target_lang: targetLang }),
  });
  if (!res.ok) throw new Error(res.status === 401 || res.status === 403 ? 'Sessão expirada — inicia sessão novamente' : 'AI assistance is unavailable');
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';
  let output = '';

  const consume = (line) => {
    if (!line.startsWith('data: ')) return;
    const payload = line.slice(6);
    if (payload === '[DONE]') return;
    const parsed = JSON.parse(payload);
    if (parsed.error) throw new Error(parsed.error);
    if (parsed.delta) {
      output += parsed.delta;
      onDelta?.(output, parsed.delta);
    }
  };

  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const lines = buffer.split('\n\n');
    buffer = lines.pop() || '';
    lines.forEach(consume);
  }
  if (buffer) consume(buffer);
  return output;
};
